
import { Component, Input } from '@angular/core';
import { NavigationNode } from '@spartacus/storefront';
import { NavLabelComponent } from '../../nav-label/nav-label.component';
import { BaseURLPipe } from '../../../../../../../core/pipes/base-url/base-url.pipe';

@Component({
  selector: 'content-3-levels',
  standalone: true,
  imports: [NavLabelComponent],
  templateUrl: './content-3-levels.component.html',
  styleUrl: './content-3-levels.component.scss',
})
export class Content3LevelsComponent {
  @Input() node!: NavigationNode;

  constructor(private baseURL: BaseURLPipe) {}

  getBaseURL(url = '') {
    return this.baseURL.transform(url);
  }
}
